import * as logger from 'logger';
import * as deviceService from 'services/device-service';
import * as tokenService from 'services/token-service';
import { Middleware, MiddlewareAPI } from 'redux';
import { GET_DEVICE_ID, SetDeviceIdAction, UNREGISTER_DEVICE } from './actions';
import { getDatabase } from 'database';
import { tenantSelector } from 'pages/settings/selectors';
import { usernameSelector } from 'pages/user-profile/selectors';
import { SaveTenantIdExistsAction } from 'pages/settings/actions';

const DeviceInfoMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {

      case GET_DEVICE_ID:
        await getDeviceId(store);
        break;

      case UNREGISTER_DEVICE:
        await unregisterDevice(store);
        break;

      default:
        break;
    }

    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'DeviceInfoMiddleware');
  }
};

async function getDeviceId(store: MiddlewareAPI): Promise<void> {
  const deviceId = await deviceService.getDeviceId();
  store.dispatch(new SetDeviceIdAction(deviceId));
}

async function unregisterDevice(store: MiddlewareAPI) {
  // send to server
  const state = store.getState();
  const tenantId = tenantSelector(state).id;
  const username = usernameSelector(state);
  await deviceService.unregisterDevice(tenantId, username);
  
  // clear IndexDB except for DeviceId, Audits & Pending Items
  const db = await getDatabase();
  for (let index in db.config.indexes) {
    if (index !== db.config.indexes.Device 
        && index !== db.config.indexes.AuditLog
        && index !== db.config.indexes.Pending
        && index !== db.config.indexes.Token) {
      await db.clear(index);
    }
  }
  // leave background token so pending items can still process
  await tokenService.removeSessionToken();

  // take the user to the device registration page
  // On register, we already refresh the page
  store.dispatch(new SaveTenantIdExistsAction(false));
}

export default DeviceInfoMiddleware;



// WEBPACK FOOTER //
// ./src/pages/device-info/middleware.ts